<template>

    <question-base :required="true"
                   class="mt-4"
                   :background-color="backgroundColor"
                   :button-color="buttonColor"
                   :next-button-text="translations.survey_complete_registration_button_text"
                   :next-button-enabled="nextButtonEnabled"
                   :back-button-enabled="false"
                   :saving="saving"
                   @next="nextClicked"
    >
        <question-header :background-color="backgroundColor"
                         :question-text="translations.survey_password_question_text"
                         :button-color="buttonColor"
        ></question-header>

        <password-field v-model="passwordModel"
                        class="mt-5"
                        :label="translations.survey_password_field_label"
                        :label-confirm="translations.survey_password_confirmation_field_label"
                        :label-security-indicator="translations.survey_password_security_indicator_label"
                        :validation-required-error="translations.survey_password_validation_required"
                        :validation-complexity-error="translations.survey_password_validation_complexity"
                        :validation-mismatch-error="translations.survey_password_validation_mismatch"
                        @valid="setPasswordValid"
                        :autoFocus="autoFocus"
                        :background-color="backgroundColor"
                        :solo="true"
        ></password-field>

        <vue-recaptcha v-if="recaptchaSiteKey"
                       class="mb-4 ml-8"
                       v-show="showCaptcha"
                       @verify="captchaVerified"
                       @expired="captchaExpired"
                       :sitekey="recaptchaSiteKey"
                       :loadRecaptchaScript="true"
        ></vue-recaptcha>

    </question-base>

</template>

<script>

import PasswordField from "../PasswordField";
import QuestionHeader from "./QuestionHeader";
import QuestionBase from "./QuestionBase"
import VueRecaptcha from 'vue-recaptcha';

export default {

    name: "PasswordQuestion",

    components: {
        PasswordField,
        QuestionHeader,
        QuestionBase,
        VueRecaptcha
    },

    props: {
        backgroundColor: {
            required: true,
            type: String,
        },
        buttonColor: {
            required: true,
            type: String,
        },
        translations: {
            required: true,
            type: Object,
        },
        recaptchaEnabled: {
            required: true,
            type: Boolean,
        },
        recaptchaSiteKey: {
            required: false,
            type: String | null,
            default: null,
        },
        autoFocus: {
            required: true,
            type: Boolean,
            default: false,
        },
        saving: {
            required: false,
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            captchaToken: null,
            passwordModel: null,
            passwordValid: false,
        }
    },

    computed: {

        nextButtonEnabled() {
            if (this.recaptchaEnabled && this.captchaToken === null) return false;
            return this.passwordValid;
        },

        showCaptcha() {
            return this.recaptchaEnabled && this.passwordValid;
        }
    },

    methods: {

        nextClicked() {

            let data = {
                password: this.passwordModel
            };

            if (this.recaptchaEnabled) {
                data.captchaToken = this.captchaToken;
            }

            this.$emit('complete', data);
        },

        captchaVerified(captchaToken) {
            this.captchaToken = captchaToken;
        },

        captchaExpired() {
            this.captchaToken = null;
        },

        setPasswordValid(valid) {
            this.passwordValid = valid;
        },
    },
}
</script>
